var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),(_vm.$store.state.openSearch)?_c('search'):_vm._e(),(_vm.$store.state.Loading)?_c('loading'):_vm._e(),_c('i',{staticClass:"fas fa-angle-up top",on:{"click":_vm.scrollToTop}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }